import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import 'whatwg-fetch';
class getTerminos extends Component {
  constructor(){
    super();
    this.state = {
        msg:""
    }
  }
  getRegresar =()=>{
    this.props.getRegresarCondiciones()
  }
  getConditions =()=>{
    const url= this.props.dir_url + "webapp/getConditions";
    console.log(url)
    const token =  this.props.token
    var obj = { accion:'vercondiciones', token};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          msg : data[0].msg[0].condiciones
        })
      }
    })
    .catch(console.log)
  }
  render() {
    return (
      <div className="cssversion_menu cssversion_colorblanco">
        <div className={(this.state.msg==='')?"cssversion_pw100 cssversion_ph80 cssversion_contentCenter":"cssversion_pw100 cssversion_ph80"} style={{"display":"flex","overflowY":"auto"}}>
          <span className="span-global">
          {(this.state.msg==='')?
            <img alt="Cargando Imagen . . ." src={ require('../../image/loading.gif') } />
            :
             ReactHtmlParser(this.state.msg)
          }
          </span>
        </div>
        <div className="cssversion_pw100 cssversion_ph20 cssversion_contentCenter">
          <button className="button-global cssversion_pw85" onClick={ () => this.getRegresar()}>
            Regresar
          </button>
        </div>
      </div>
    )
  }

  componentDidMount (){
    this.getConditions()
  }


}
export default getTerminos;
